import {ValueObject} from '@s-ui/domain'

export class WhatsappIntentsUserValueObject extends ValueObject {
  #chatDeepLink
  #id

  /**
   * @param {string} chatDeepLink
   * @param {string} id
   * */
  static create({chatDeepLink, id}) {
    return new WhatsappIntentsUserValueObject({chatDeepLink, id})
  }

  constructor({chatDeepLink, id}) {
    super()
    this.#chatDeepLink = chatDeepLink
    this.#id = id
  }

  get chatDeepLink() {
    return this.#chatDeepLink
  }

  get id() {
    return this.#id
  }

  get value() {
    return {
      chatDeepLink: this.#chatDeepLink,
      id: this.#id
    }
  }

  toJSON() {
    return {
      chatDeepLink: this.#chatDeepLink,
      id: this.#id
    }
  }
}
